<script>
import Multiselect from "vue-multiselect";

import api from "../../services/api";

/**
 * Nav-bar Component
 */
export default {
  components: {Multiselect},
  props: {
    address: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      listCommunes: [],
      listCountry: [],
    };
  },
  beforeMount() {
    if (sessionStorage.getItem('communes'))
      this.listCommunes = JSON.parse(sessionStorage.getItem('communes'));
    else {
      api.get('communes', {sortBy: 'name'}).then((response) => {
        this.listCommunes = response.data.data;
        sessionStorage.setItem('communes', JSON.stringify(this.listCommunes));

        return this.listCommunes;
      });
    }

    if (sessionStorage.getItem('countries'))
      this.listCountry = JSON.parse(sessionStorage.getItem('countries'));
    else {
      api.get('countries', {sortBy: 'name'}).then((response) => {
        this.listCountry = response.data.data;
        sessionStorage.setItem('countries', JSON.stringify(this.listCountry));

        return this.listCountry;
      });
    }
  },
  methods: {}
};
</script>

<template>

  <b-form>
    <b-card no-body class="mb-2 pt-2">
      <b-card-body class="p-0">
        <b-row class="mb-3">
          <b-col>
            <b-form-group label="Adresse" label-for="formrow-address-input">
              <b-form-input id="formrow-address-input"
                            :readonly="readOnly"
                            v-model="address.street"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Commune" label-for="formrow-commune-input">
              <multiselect
                  id="formrow-commune-input"
                  v-model="address.commune"
                  :options="listCommunes"
                  label="name"
                  track-by="id"
                  :show-labels="false"
                  :disabled="readOnly"
              >
              </multiselect>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Pays" label-for="formrow-pays-input">
              <multiselect
                  id="formrow-pays-input"
                  v-model="address.country"
                  :options="listCountry"
                  label="name"
                  track-by="id"
                  :show-labels="false"
                  :disabled="readOnly"
              >
              </multiselect>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </b-form>
</template>